module.exports = __webpack_public_path__ + "media/images/site/serie-a-f09982280212246395e3cc45b393d861.png";